import React from 'react';
import DoctorShiftRuleListContainer from './container/DoctorShiftRuleListContainer';
import { doctorShiftRuleRepository } from '../../../infrastructure/repositories/DoctorShiftRuleRepositoryImpl';

/**
 * 医師シフトルール一覧ページ
 *
 * - ページタイトル「医師シフトルール」
 * - レイアウト統合
 * - Container組み込み
 */
export const DoctorShiftRuleListPage: React.FC = () => {
  return <DoctorShiftRuleListContainer repository={doctorShiftRuleRepository} />;
};

export default DoctorShiftRuleListPage;
